import React from "react";
import loader from "../Loader2/redcliffe.gif";
function Loader() {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
     <img src={loader} alt="Loading" style={{width:"100px",height:"100px"}} />
    </div>
  );
}

export default Loader;
